function isSafeInternalReturnPath(value) {
  return Boolean(
    typeof value === 'string'
    && value.startsWith('/')
    && !value.startsWith('//')
    && !value.includes('\\')
    && !/[\u0000-\u0020\u007f]/.test(value),
  );
}

function normalizePaymentReturnPath(value) {
  if (!isSafeInternalReturnPath(value)) return '/explore';
  // URL normalization removes dot segments; check the actual navigation target.
  try {
    const url = new URL(value, 'https://payment-return.invalid');
    if (url.origin !== 'https://payment-return.invalid' || url.pathname.startsWith('//')
      || /^\/payment\/(order|checkout)(\/|$)/.test(decodeURIComponent(url.pathname))) return '/explore';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return '/explore'; }
}

function buildPaymentOrderStatusPath(orderId, returnTo) {
  const normalizedOrderId = typeof orderId === 'string' ? orderId.trim() : '';
  if (!normalizedOrderId || normalizedOrderId.length > 128) {
    return normalizePaymentReturnPath(returnTo);
  }
  const safeReturnTo = normalizePaymentReturnPath(returnTo);
  return `/payment/order/${encodeURIComponent(normalizedOrderId)}?from=${encodeURIComponent(safeReturnTo)}`;
}

function buildPaymentAuthRecoveryPath(orderId, returnTo) {
  const safeReturnTo = normalizePaymentReturnPath(returnTo);
  return `/login?redirect=${encodeURIComponent(safeReturnTo)}&login=1`;
}

function resolvePaymentReturnDestination(outcome, orderId, returnTo) {
  const safeReturnTo = normalizePaymentReturnPath(returnTo);
  if (outcome === 'auth_expired') {
    return buildPaymentAuthRecoveryPath(orderId, safeReturnTo);
  }
  // Payment state remains available under the signed-in account's order
  // records; callback outcomes must never interrupt the purchase journey with
  // a standalone order-detail page.
  return safeReturnTo;
}

module.exports = {
  buildPaymentAuthRecoveryPath,
  buildPaymentOrderStatusPath,
  isSafeInternalReturnPath,
  normalizePaymentReturnPath,
  resolvePaymentReturnDestination,
};
